module.exports = __webpack_public_path__ + "Flag-840.f643a3808a0cb6f22670a67f23c3ac52.svg";